import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { STEPS } from "../../lib/content";

export const Steps = ({ light = false }) => (
  <div className="relative">
    <div aria-hidden="true" className={`absolute left-0 right-0 top-7 hidden h-px lg:block ${light ? "bg-white/15" : "bg-forest/15"}`}>
      <motion.div className="h-px origin-left bg-leaf" initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }} />
    </div>
    <ol className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
      {STEPS.map((s, i) => {
        const Icon = s.icon;
        return (
          <Reveal as="li" key={s.title} delay={i * 0.12} className="relative">
            <div data-testid={`step-${i + 1}`} className="flex items-center gap-4">
              <span className="relative z-10 grid h-14 w-14 place-items-center rounded-full bg-gold font-display text-lg font-semibold text-forest">{i + 1}</span>
              <Icon className={`h-5 w-5 ${light ? "text-white/70" : "text-forest/60"}`} strokeWidth={1.6} />
            </div>
            <h3 className={`mt-6 font-display text-xl font-medium leading-snug tracking-tight ${light ? "text-white" : "text-forest"}`}>{s.title}</h3>
            <p className={`mt-3 text-[15px] leading-relaxed ${light ? "text-white/75" : "text-ink/75"}`}>{s.text}</p>
          </Reveal>
        );
      })}
    </ol>
  </div>
);
